import comp from "./AddEvidenceModal";
export default comp;
